
<div class="row">
    <div class="col col-12">
        <app-header></app-header>

        <app-carousel></app-carousel>

        <app-features></app-features>

        <app-quickmenu></app-quickmenu>

        <app-viewcomments></app-viewcomments>

        <app-contactsec></app-contactsec>
        
        <app-footer></app-footer>

    </div>
</div>  
